import React from 'react';
import { CheckIcon } from 'lucide-react';
const NUMBERS = [{
  value: '6',
  label: 'Complete Modules'
}, {
  value: '5',
  label: 'Strategic Bonuses'
}, {
  value: 'Pro',
  label: 'Teaching Level'
}, {
  value: 'Full',
  label: 'Classroom Coverage'
}];
const COVERAGE = ['Visual Supports', 'Adaptable Activities', 'Differentiation Tools', 'Classroom Routines', 'Planning Resources', 'Progress Tracking', 'Communication Supports', 'Individual, Small-Group & Classroom Use'];
export function SystemOverview() {
  return <section aria-labelledby="system-title" className="w-full bg-cream px-3 py-7 sm:px-5" data-id="element-210" data-mp="pxg8m966lmvy">
      <div className="mx-auto max-w-4xl text-center" data-id="element-211" data-mp="13wfvbba4vrph">
        <span className="font-head text-[10px] uppercase tracking-[0.14em] text-steel sm:text-xs" data-id="element-212" data-mp="13ttgqrotsbxr">
          The complete system to stop rebuilding your materials
        </span>
        <h2 id="system-title" className="mt-1 font-head text-3xl uppercase leading-none text-ink sm:text-5xl" data-id="element-213" data-mp="2f9i3pj22xayk">
          Special Education Teacher Pro™
        </h2>
        <p className="mx-auto mt-2 max-w-2xl text-[13px] leading-snug text-muted sm:text-base" data-id="element-214" data-mp="235cghnbqvmog">
          Visual supports, adaptable activities, differentiation tools, classroom routines, planning
          resources, progress tracking, and ready-to-use materials. Everything organized and ready
          when you need it.
        </p>

        <dl className="mt-4 grid grid-cols-2 gap-1.5 lg:grid-cols-4" data-id="element-215" data-mp="2i2vc99mub05e">
          {NUMBERS.map(item => <div key={item.label} className="rounded-xl border border-ink/10 bg-white py-3" data-id="element-216" data-mp="1khpn0gel4ggk">
              <dd className="font-head text-2xl uppercase leading-none text-petrol sm:text-3xl" data-id="element-217" data-mp="1pfhbt1jxnmgj">
                {item.value}
              </dd>
              <dt className="mt-1 text-[9px] font-bold uppercase tracking-widest text-muted sm:text-[11px]" data-id="element-218" data-mp="1z4itcw64mbwm">
                {item.label}
              </dt>
            </div>)}
        </dl>

        <p className="mt-5 font-head text-base uppercase tracking-wide text-ink sm:text-xl" data-id="element-219" data-mp="16ohveoqi7kyv">
          Complete support for professional special education teaching
        </p>
        <ul className="mt-2 grid grid-cols-2 gap-1.5 text-left lg:grid-cols-4" data-id="element-220" data-mp="ylz6x6j1oky5">
          {COVERAGE.map(item => <li key={item} className="flex items-start gap-1.5 rounded-lg border border-sage/40 bg-sage/10 px-2.5 py-1.5 text-[11px] font-semibold leading-snug text-ink sm:text-[13px]" data-id="element-221" data-mp="tmmiwigft7tz">
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-sage" aria-hidden="true" data-id="element-222" data-mp="13f0jv8zoyaf3" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}